<template>
    <div class="map-list-container widget">
        <el-dropdown>
            <el-button>{{ nowBaseLayerName }}<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(source, index) in baseLayerConfig.baseLayerList" :key="index"
                    :class="{ 'bord': index == baseLayerConfig.chosenSourceId }" @click.native="changeBaseMap(index)">
                    {{ source.name }}
                </el-dropdown-item>
                <el-dropdown-item @click.native="dialogVisible = !dialogVisible" divided>管理地图</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>


        <!-- 管理地图源的对话框 -->
        <el-dialog :visible.sync="dialogVisible" title="管理地图源" :append-to-body="true" width="50%">
            <!-- 地图源列表表格 -->
            <el-table :data="baseLayerConfig.baseLayerList" style="width: 100%">
                <el-table-column prop="name" label="地图源名称">
                </el-table-column>
                <el-table-column label="操作" width="120px">
                    <template slot-scope="scope">
                        <span v-if="scope.row.owner == -1" style="color: green;">系统自带</span>
                        <el-button v-else size="mini" type="danger" @click="del(scope.$index)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 添加新地图源的输入框和按钮 -->
            <div style="margin-top: 20px;text-align: right">
                <el-button type="success" @click="addDialogVisible = true">添加图源</el-button>
            </div>


            <!-- 添加地图源的对话框 -->
            <el-dialog :visible.sync="addDialogVisible" title="添加新地图源" width="50%" :append-to-body="true">
                <el-form ref="form" :model="form" :rules="rules" label-width="80px">
                    <el-form-item label="名称" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>
                    <el-form-item label="URL地址" prop="url">
                        <el-input v-model="form.url"></el-input>
                    </el-form-item>
                    <el-form-item>
                        url格式样式：http://www.map.org/{z}/{x}/{y}.png,{z}、{x}、{y}为必要参数。
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="saveMapSource" :loading="saveIsLoading">确 定</el-button>
                </span>
            </el-dialog>

        </el-dialog>
    </div>

</template>
<script>
import { baseLayerConfig } from '@/util/mapManager.js'
import checkUtil from '@/util/commonUtil.js'
import { addMapSource, delMapSource } from '@/util/request.js'

export default {
    name: 'MapList',
    methods: {
        del(index) {
            this.$confirm('是否要删除这个图源', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 用户点击了“确定”，在这里处理确认后的逻辑
                let baseLayer = baseLayerConfig.baseLayerList[index]
                let id = baseLayer.id
                delMapSource(id).then(
                    res => {
                        if (res.resultCode == 1) {
                            let sourceArr = res.result
                            baseLayerConfig.baseLayerList = sourceArr
                            this.$message.success('删除成功')
                        }
                    }
                )
            }).catch(() => {
                // 用户点击了“取消”，在这里处理取消后的逻辑

            });
        },
        saveMapSource() {
            console.log('validate')
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    let check = checkUtil.isMapSource(this.form.url)
                    if (check) {
                        this.saveIsLoading = true
                        addMapSource(
                            {
                                name: this.form.name,
                                url: this.form.url
                            }
                        ).then(res => {
                            if (res.resultCode == 1) {
                                let sourceArr = res.result
                                baseLayerConfig.baseLayerList = sourceArr
                                this.$message.success('添加成功')
                                this.addDialogVisible = false
                            } else
                                this.$message.error('添加错误')
                            this.saveIsLoading = false
                        })
                    } else {
                        this.$message.error('地图源地址不规范')
                    }
                }
            })
        },
        closeDialog() {
            this.addDialogVisible = false;
        },
        changeBaseMap(index) {
            baseLayerConfig.setMapSource(index)
        }
    },
    computed: {
        nowBaseLayerName() {
            if (baseLayerConfig.getBaseLayerSource() == null) {
                return ''
            } else
                return baseLayerConfig.getBaseLayerSource().name
        }
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            dialogVisible: false,
            addDialogVisible: false,
            baseLayerConfig,
            saveIsLoading: false,
            form: {
                name: '',
                url: ''
            },
            rules: {
                name: [
                    { required: true, message: '请输入名称', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: '请输入URL地址', trigger: 'blur' }
                ]
            }
        }
    }
}
</script>
<style scoped>
.map-list-container {
    top: 100px;
    right: 16px;
}

.el-dialog {
    width: 600px;
}

.bord {
    font-weight: bold;
    color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/main/MapList.vue